import React, { useContext, useEffect, useState } from "react";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import IBSTypeGroup from "./IBSTypeGroup";

const WebMapDataType = ({ type, data = [] }) => {
  const {
    supplyFilters, demandFilters,
    onChangeSupplyDataType,
    onChangeDemandDataType,
  } = useContext(WebMapContext);
  const [value, setValue] = useState();

  useEffect(() => {
    setValue(null);
    if (data.length > 0) {
      let val = data[0].value;
      if (type === 'supply_best' && supplyFilters.dataType.best)
        val = supplyFilters.dataType.best;
      else if (type === 'supply_custom' && supplyFilters.dataType.custom)
        val = supplyFilters.dataType.custom;
      else if (type === 'demand' && demandFilters.dataType)
        val = demandFilters.dataType;
      data.some(item => item.value === val) ? setValue(val) : setValue(data[0].value)
    }
  }, [data,type])

  useEffect(() => {
    if (value) {
      if (type === 'supply_best')
        onChangeSupplyDataType({ ...supplyFilters.dataType, best: value });
      else if (type === 'supply_custom')
        onChangeSupplyDataType({ ...supplyFilters.dataType, custom: value });
      else
        onChangeDemandDataType(value);
    }
  }, [value]);

  return (
    <>
      <div style={{ width: "100%", fontSize: "5px" }}>
        {value && data.length > 0
          ? <IBSTypeGroup
            data={data}
            value={value}
            handleChange={(val) => setValue(val)}
          />
          : <></>}
      </div>
    </>
  )
};

export default WebMapDataType;